import React from 'react';
import { Checkbox } from '@mui/material';
import { IconCheckboxSelected, IconCheckboxUnselected } from 'src/common/images';

function CustomCheckbox(props, ref) {
    return <Checkbox icon={<IconCheckboxUnselected />} checkedIcon={<IconCheckboxSelected />} {...props} />;
}

export default React.forwardRef(CustomCheckbox);
